import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-bin-bold",
  "use": "foquz-icon-bin-bold-usage",
  "viewBox": "0 0 17 18",
  "content": "<symbol viewBox=\"0 0 17 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-bin-bold\"><path d=\"M14.5 3H16m-1.5 0l-.86 11.215a2 2 0 01-2.01 1.847l-6.28-.05a2.015 2.015 0 01-1.992-1.859L2.5 3m12 0h-12M1 3h1.5m8 3l-.5 7M6.5 6l.5 7M6 3V2a1 1 0 011-1h3a1 1 0 011 1v1\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol